import cookie from 'js-cookie'

export default async (Vue) => {
  const [, accounts] = await Promise.all([
    Vue.$store.dispatch('setMe'),
    Vue.$store.dispatch('selectAccounts'),
    Vue.$store.dispatch('setResources')
  ])

  const selectedAccountId = cookie.get('selected_account_id')
  const account = accounts.find(v => v._id === selectedAccountId) || accounts[0]

  if (!account || !account._id) {
    Vue.$router.push('/my-account') // Não há contas
    return
  }

  try {
    await Vue.$store.dispatch('selectAccount', account._id)
  } catch (err) {
    Vue.$router.push('/auth')
    return
  }

  // não aguarda: o menu é atualizado quando a lista chegar
  Vue.$store.dispatch('setMenuCareersites')
}



// WEBPACK FOOTER //
// ./src/utils/Bootstrapping.js